const steering = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5a6.5 6.5 0 0 1 6.45 5.75h-4.08a2.48 2.48 0 0 0-4.74 0H1.55A6.5 6.5 0 0 1 8 1.5M1.55 8.75h4.08a2.47 2.47 0 0 0 1.62 1.62v4.08a6.48 6.48 0 0 1-5.7-5.7m7.2 5.7v-4.08a2.47 2.47 0 0 0 1.62-1.62h4.08a6.48 6.48 0 0 1-5.7 5.7"/></svg>',
};

export { steering as default };
